import { z } from 'zod';
import { zDbId } from '~/plugins/zod/utils';
import { AppUserSimpleSchema } from '../links/_types';

export const ContactSimpleSchema = z.object({
    Id: zDbId(),
    FullName: z.string(),
});

export const ContactInfoSchema = ContactSimpleSchema.and(
    z.object({
        IsActive: z.boolean(),
        IsDefault: z.boolean(),
        Email: z.string().nullable(),
    })
);

export const ContactDetailSchema = ContactInfoSchema.and(
    z.object({
        Phone1: z.string().nullable(),
        Phone2: z.string().nullable(),
        Mobile: z.string().nullable(),
        User: AppUserSimpleSchema.nullish(),
    })
);

export const FetchContactsResponseSchema = z.array(ContactDetailSchema);
export const FetchEnumContactsResponseSchema = z.array(ContactSimpleSchema);

export type ContactSimple = z.infer<typeof ContactSimpleSchema>;
export type ContactInfo = z.infer<typeof ContactInfoSchema>;
export type ContactDetail = z.infer<typeof ContactDetailSchema>;
export type FetchContactsResponse = z.infer<typeof FetchContactsResponseSchema>;
export type FetchEnumContactsResponse = z.infer<typeof FetchEnumContactsResponseSchema>;
